module.exports = __webpack_public_path__ + "img/5-notes.00ede3b7.svg";